<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
						</el-form-item>
						
						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.email_no" placeholder="編號"></el-input>
						</el-form-item>

						<el-form-item label="發送人" class="mb-0">
							<el-input size="small" v-model="from.send_name" placeholder="發送人"></el-input>
						</el-form-item>

						<el-form-item label="接收人" class="mb-0">
							<el-input size="small" v-model="from.in_name" placeholder="接收人"></el-input>
						</el-form-item>

						<el-form-item label="接收人類型" class="mb-0">
							<el-select v-model="from.in_type" size="small" placeholder="請選擇接收人類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="平台" :value="1"></el-option>
								<el-option label="機構" :value="2"></el-option>
								<el-option label="學校" :value="3"></el-option>
								<el-option label="學生" :value="4"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇郵件類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="普通郵件" :value="1"></el-option>
								<el-option label="題目反饋" :value="2"></el-option>
								<el-option label="比賽郵件" :value="3"></el-option>
								<el-option label="訂單郵件" :value="4"></el-option>
								<el-option label="贈送禮物" :value="5"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="已讀狀態" class="mb-0">
							<el-select v-model="from.check_status" size="small">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="已讀" :value="1"></el-option>
								<el-option label="未讀" :value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>


						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>


				<el-table-column align="center" width="120" prop="email_no" label="編號">
				</el-table-column>

					
				<el-table-column align="center"   prop="user_name" label="發送人">
					<template slot-scope="v">
						<span class="text-primary" v-if="v.row.out_type==1">平台</span>
						<span class="text-warning" v-if="v.row.out_type==2">
							機構 - <span class="text-warning">{{ v.row.out_ins_data.name }}</span>
						</span>
						<span class="text-info" v-if="v.row.out_type==3">
							學校 - <span class="text-info">{{ v.row.out_school_data.name}}</span>
						</span>
						<span class="text-success" v-if="v.row.out_type==4">
							{{ v.row.out_user_data.user_no }} - <span class="text-success">{{ v.row.out_user_data.name }}</span>
						</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="user_name" label="接收人">
					<template slot-scope="v">
						<span class="text-primary" v-if="v.row.in_type==1">平台</span>
						<span class="text-warning" v-if="v.row.in_type==2">
							機構 - <span class="text-warning">{{ v.row.ins_data.name }}</span>
						</span>
						<span class="text-info" v-if="v.row.in_type==3">
							學校 - <span class="text-info">{{ v.row.school_data.name}}</span>
						</span>
						<span class="text-success" v-if="v.row.in_type==4">
							{{ v.row.user_data.user_no }} - <span class="text-success">{{ v.row.user_data.name }}</span>
						</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="title" width="200"  label="發送標題">
				</el-table-column>
				
				<el-table-column align="center" width="80" prop="content" label="郵件內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,1)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>

				<el-table-column align="center" width="80" prop="reply_content" label="回覆郵件">
						<template slot-scope="scope">
								<div v-if="scope.row.is_reply" slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,2)">
									<el-tag size="medium">查看</el-tag>
								</div>
								<div v-else slot="reference">
									未回覆
								</div>
						
						</template>
				</el-table-column>

				<el-table-column align="center" prop="check_status" width="80" label="是否已讀">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.check_status==0">未讀</span>
						<span class="text-success" v-if="v.row.check_status==1">已讀</span>
					</template>
				</el-table-column>

				<el-table-column align="center"  prop="type"  label="類型">
					<template slot-scope="v">
						<span style="color: teal;" v-if="v.row.type==1">普通郵件</span>
						<span class="text-warning"   v-if="v.row.type==2">
							題目反饋 - <span class="text-primary"   >{{ v.row.topic_no }}</span>
						</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="160" label="發送時間">
				</el-table-column>
				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="deleteItem(scope.row)"  v-auth="'delUserEmail'" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>
		

		<el-dialog :close-on-click-modal="false"  
			:visible.sync="dialogVisible" 
			:width="layout.is_phone ? '90%' : '70%'" 
			title="郵箱信息" 
			@close="closeDialog"
			>
			<!-- 郵件信息头部 -->
			<div v-if="dialogType == 1" class="dialog-header">
				<div class="email-info">
				<p><strong>標題：</strong> {{ emailTitle }}</p>
				<p><strong v-if="is_reply == 1">發送人：</strong><strong v-if="is_reply == 2">回覆人：</strong> {{ senderName }}</p>
				<p><strong>發送時間：</strong> {{ sendTime }}</p>
				</div>
			</div>
			
			
			<!-- 郵件内容 -->
			<div v-html="dialogContent" class="dialog-content"></div>
			
			<!-- 弹框底部 -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">關 閉</el-button>
			</span>
		</el-dialog>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogContent: '' ,         // 存储當前对话框的内容

				emailTitle: '' ,         // 
				senderName: '' ,         // 
				sendTime: '' ,         // 
				dialogType:1,

				dialogVisible: false,
				dialogTitleVisible: false,
				submitLoading: false,
				fullTitle: '',
				is_reply: 1,
				
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					content:'',
					email_no:'',
					send_name:'',
					in_name:'',
					in_type: -1,
					type: -1,
					status:'-1',
					check_status: -1,
					uid:'',
					time: [],
				},
				model_title: 'UserEmail',
				auth_val: 'UserEmail',
				preUrl: "data/UserEmailList", //列表地址
				delAllUrl: "data/delEmailAll", //批量删除地址
				delUrl: "data/delEmail", //删除單条地址
                editStatusUrl: "data/editStatusUserEmail", //修改狀態地址

				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					appoint_id:0,
					all_type:0,
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			  closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},

			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			openDialog(e,type) {
				let row = e.row
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.reply_title; // 设置要顯示的 HTML 内容
					this.senderName = row.reply_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.reply_time; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.title; // 设置要顯示的 HTML 内容
					this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
					this.emailRead(row)
				}
				
				this.dialogType = 1; // 设置要顯示的 HTML 内容
				this.is_reply = type; // 设置要顯示的 HTML 内容
				this.replyData = e; // 设置要顯示的 HTML 内容
				
				// if(row.status == 0){
				// 	this.changeStatus(row,1,false,true)
				// }
				this.dialogVisible = true;    // 顯示对话框
			},
			emailRead(e){
				if(e.check_status == 0){
					this.axios.post('/admin/data/emailRead', {
						type: 1,
						id:e.id,
					}, {
						token: true,
					}).then(res => {
						this.getList()
						this.layout.getPageNum();
					})
				}
			},

			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						appoint_id:e.appoint_id,
						all_type:e.all_type,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						appoint_id:0,
						all_type:0,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					content:'',
					email_no:'',
					send_name:'',
					in_name:'',
					in_type: -1,
					type: -1,
					status:'-1',
					check_status: -1,
					uid:'',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
